"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPickerProps = void 0;
exports.DefaultPickerProps = {
    disabled: false,
    noBorder: false,
    noMargin: false,
    white: false,
    fullWidth: false,
};
